import type { InputRef } from 'antd';
import { Button, Card, Input } from 'antd';
import React, { useRef, useState } from 'react';

import { firebaseFunctions } from '../../../firebase/firebase';
import { FirebaseCallableFunctions } from '../../../firebase/firebase.models';

import { NotificationType, openNotification } from './openNotification';

export const AddAdmin: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const inputRef = useRef<InputRef>(null);

  const addAdminClaim = async () => {
    setLoading(true);
    try {
      await firebaseFunctions.httpsCallable(FirebaseCallableFunctions.ADD_ADMIN_CLAIM)({ email: userEmail });
      openNotification(NotificationType.SUCCESS, 'Admin claim added successfully');

      if (inputRef.current) {
        inputRef.current.input.value = '';
      }
    } catch (error: any) {
      openNotification(NotificationType.ERROR, 'Error while adding admin claim - see console for more details');
      console.error('Error while adding admin claim:', error);
    }
    setLoading(false);
    setUserEmail('');
  };

  return (
    <Card title="Add Admin">
      <Input
        ref={inputRef}
        placeholder="Enter email"
        name="email"
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value)}
      />
      <Button type="primary" onClick={addAdminClaim} loading={loading} block className="mt-2">
        Add Admin
      </Button>
    </Card>
  );
};
